import config from '../Common/Configurations/APIConfig';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import auth from '../Common/Configurations/Auth';
import { handleSuccess, handleError } from '../Common/Layout/CustomAlerts';
import Footer from '../Common/Layout/Footer';
const initialLoginValues = {
  email: '',
  password: ''
};
export default function Login() {
  const navigate = useNavigate();
  const [values, setValues] = useState(initialLoginValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const applicationAPI = (url = config.APIACTIVATEURL + config.LOGIN) => {
    return {
      userlogin: (newRecord) => axios.post(url, newRecord),
    };
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const validate = () => {
    let temp = {};
    temp.email = values.email == '' ? false : true;
    temp.password = values.password == '' ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x == true);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setBtnSubmit(false);
        const formData = new FormData()
        formData.append("email", values.email)
        formData.append("password", values.password)
        checkUser(formData);
      } catch (err) {
        setBtnSubmit(true);
        handleError('Please check the mandatory fields');
      }
    } else {
      setBtnSubmit(true);
      handleError('Please check the mandatory fields');
    }
  };
  const checkUser = (loginData) => {
    applicationAPI()
      .userlogin(loginData)
      .then((response) => {
        if (response.status === 200) {
          setBtnSubmit(true);
          setValues(initialLoginValues);
          var logindata = response.data.loginResponse;
          if (response.data.statusCode === 500) {
            var errordata = response.data.message;
            setBtnSubmit(true);
            if (errordata.message === "No active subscription available") {
              navigate('/register/subscription/' + errordata.clientId);
            }
            else {
              handleError(errordata.message);
            }
          }
          else if (logindata.status) {
            localStorage.setItem('userId', logindata.userId);
            localStorage.setItem('clientId', logindata.clientId);
            localStorage.setItem('roleName', logindata.role);
            localStorage.setItem('userToken', logindata.token);
            localStorage.setItem('tokenexpiration', logindata.expiration);
            if (logindata.role === "ADMIN") {
              navigate('/dashboard');
            }
            else if (logindata.role === "CLIENT") {
              navigate('/userdashboard');
            }
            else if (logindata.role === "BROKER") {
              navigate('/broker/dashboard');
            }
            else {
              navigate('/');
            }
          }
          else {
            handleError(response.data.message);
            setBtnSubmit(true);
          }
        } else {
          handleError(response.data.message);
          setBtnSubmit(true);
        }
      })
      .catch(function (error) {
        handleError(error);
        setBtnSubmit(true);
      });
  };
  useEffect(() => {
    if (localStorage.getItem('userToken') !== '') {
      if (CheckExpirationTime()) {
        if (localStorage.getItem('roleName') === 'CLIENT') {
          navigate('/userdashboard');
        } else if (localStorage.getItem('roleName') === 'ADMIN') {
          navigate('/dashboard');
        } else {
          navigate('/login');
        }
      }
    } else {
      navigate('/login');
    }
  }, []);
  function CheckExpirationTime() {
    if (localStorage.getItem('tokenexpiration') !== '') {
      const expiredate = new Date(localStorage.getItem('tokenexpiration'));
      const localdate = new Date();
      if (expiredate > localdate) {
        return true;
      }
    }
    return false;
  }
  const applyErrorClass = (field) =>
    field in errors && errors[field] == false ? ' form-control-danger' : '';
  return (
    <>
      <div className="auth-back-cover" style={{ backgroundColor: "#39279D" }}>
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          {/* auth-page content */}
          <div className="auth-page-content overflow-hidden mt-lg-4">
            <div className="container">
              <div className="row">
                <div className="col-lg-5">
                  <div className="card overflow-hidden rounded-4 loginbox">
                    <div className="row g-0">
                      <div className="p-lg-5 p-4">
                        <div>
                          <img src="/assets/images/logo3d.jpg"></img>
                        </div>
                        <p className="text-muted" style={{ textAlign: 'center' }}>
                          Sign in to continue...
                        </p>
                        <div className="mt-4">
                          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">Email</label>
                              <input className={'form-control' + applyErrorClass('email')} name="email" type="text" value={values.email} onChange={handleInputChange} placeholder="Enter Email" />
                              {errors.email === false ? (<div className="validationerror">Please enter email</div>) : ('')}
                            </div>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="password-input">Password</label>
                              <div className="position-relative auth-pass-inputgroup mb-1">
                                <input
                                  className={'form-control' + applyErrorClass('password')}
                                  name="password"
                                  type={showPassword ? 'text' : 'password'}
                                  value={values.password}
                                  onChange={handleInputChange}
                                  placeholder="Password"
                                />
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                  }}
                                  onClick={togglePasswordVisibility}
                                >
                                  {showPassword ? (
                                    <i className="fa fa-eye"></i>
                                  ) : (
                                    <i className="fa fa-eye-slash"></i>
                                  )}
                                </span>
                              </div>
                              {errors.password === false && (
                                <div className="validationerror">Please enter password</div>
                              )}
                            </div>
                            <div className="mt-4 d-flex justify-content-end">
                              {btnSubmit === true ?
                                (<button type="submit" className="btn btn-success w-100">Sign In</button>)
                                :
                                (<button type="button" className="btn btn-primary w-100" disabled>Please wait...</button>)
                              }
                              <Link to="/" className="btn btn-danger me-2 w-100">Back</Link>
                            </div>
                          </form>
                        </div>
                        <div class="mt-3 text-center">
                        <p class="mb-2">Forgot Password? <Link to={"/forgotpassword"} class="fw-semibold text-primary text-decoration-underline"> Click Here?</Link></p>
                          <p class="mb-0">Don't have an account ? <Link to={"/register"} class="fw-semibold text-primary text-decoration-underline"> Register</Link></p>
                        </div>
                      </div>
                      {/* end col */}
                    </div>
                    {/* end row */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end container */}
          </div>
          {/* end auth page content */}
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
